import { Component, Input } from '@angular/core';

@Component({
    selector: 'finder-layout',
    templateUrl: './finder-layout.component.html',
    styleUrls: ['./finder-layout.component.scss']
})
export class FinderLayoutComponent {
    @Input() error: any;
    @Input() languageBundle: any;
    @Input() loaded = false;

    constructor() { }
}
